export let standardSynonyms = [
  {
    name: 'да',
    words: ['да', 'да-да', 'да да', 'дада', 'ну да', 'согласен', 'ага', 'угу', 'конечно', 'верно', 'так точно', 'да-да-да', 'да да да', 'дадада', 'ok']
  },
  {
    name: 'нет',
    words: ['нет', 'неа', 'нео', 'neo', 'не надо', 'не нужно', 'не хочу', 'ни за что', 'ни в коем случае', 'не хотим', 'не можем']
  },
  {
    name: 'yes',
    words: ['yes', 'okay', 'yeah', 'right', 'ready', 'really', 'wish', 'verily', 'sure', 'okay', 'sure', 'easy', 'well', 'well yes', 'Well, of course', 'However', 'OK']
  },
  {
    name: 'no',
    words: ['no', 'no no', 'not at all', 'wait', 'pipes', 'no fools', 'look for a fool', 'do not', 'not necessary', 'I do not want', 'no shit', 'nope', 'impossible', 'out of place']
  },
  {
    name: 'tak',
    words: ['tak', 'dobrze', 'tak', 'dobrze', 'gotowe', 'naprawdę', 'życzę', 'bardzo', 'jasne', 'dobrze', 'jasne', 'łatwe', 'dobrze', 'cóż tak', 'cóż', 'oczywiście', 'jednak', 'ok']
  },
  {
    name: 'nie',
    words: ['nie', 'nie nie', 'wcale nie', 'czekaj', 'rury', 'nie ma głupców', 'szukaj głupca', 'nie', 'nie jest konieczne', 'nie chcę', 'nie ma gówna', 'niemożliwe', 'nie na miejscu']
  }
]



// WEBPACK FOOTER //
// ./client/views/scenarios/konstruktor/standardSynonyms.js